import styled from "styled-components";

export const ChecklistWrapper = styled.section`
  width: 100%;
  max-width: min(700px, 100%);
  box-sizing: border-box;
  overflow-x: hidden;
  margin: 0.35rem auto 0;
  padding: 1rem 1rem 2rem;
  color: #ffffff;
  font-family: "Inter", sans-serif;

  @media screen and (max-width: 768px) {
    margin-top: 0;
    padding: 0.65rem 1rem calc(8.75rem + env(safe-area-inset-bottom, 0px));
  }
`;

export const Header = styled.div`
  display: block;
  margin-bottom: 0.9rem;

  h2 {
    margin: 0;
    max-width: min(100%, calc(100vw - 2rem));
    font-size: clamp(1.55rem, 3.1vw, 1.9rem);
    line-height: 1.14;
    font-weight: 650;
    letter-spacing: -0.02em;
    text-wrap: balance;
    white-space: normal;
    overflow-wrap: break-word;
  }

  p {
    margin: 0.32rem 0 0;
    color: #9aa8bd;
    font-size: 1.05rem;
    line-height: 1.35;
  }

  @media screen and (max-width: 520px) {
    margin-bottom: 0.82rem;

    h2 {
      font-size: clamp(1.18rem, 5vw, 1.34rem);
      line-height: 1.18;
    }

    p {
      margin-top: 0.24rem;
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 360px) {
    h2 {
      font-size: 1.22rem;
    }
  }
`;

export const Progress = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: 0.72rem;
  padding: 0.34rem 0.72rem;
  border: 1px solid rgba(184, 132, 255, 0.34);
  border-radius: 999px;
  color: #d7c8ff;
  background:
    linear-gradient(135deg, rgba(145, 92, 255, 0.22), rgba(90, 44, 160, 0.08)),
    rgba(18, 12, 32, 0.76);
  box-shadow: 0 0 0 1px rgba(138, 93, 246, 0.05) inset;
  font-size: 0.84rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
`;

export const StepList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
`;

export const StepButton = styled.button<{ $complete?: boolean }>`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  align-items: center;
  gap: 0.82rem;
  min-height: 5.35rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid
    ${({ $complete }) =>
      $complete ? "rgba(100, 225, 142, 0.24)" : "rgba(255, 255, 255, 0.075)"};
  border-radius: 16px;
  color: inherit;
  background: ${({ $complete }) =>
    $complete
      ? "linear-gradient(135deg, rgba(28, 92, 49, 0.27), rgba(8, 22, 14, 0.68))"
      : "linear-gradient(135deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.014))"};
  text-align: left;
  cursor: ${({ $complete }) => ($complete ? "default" : "pointer")};
  transition:
    border-color 160ms ease,
    background 160ms ease,
    transform 160ms ease;

  &:not(:disabled):hover {
    border-color: ${({ $complete }) =>
      $complete ? "rgba(100, 225, 142, 0.3)" : "rgba(174, 123, 255, 0.22)"};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid #8b5cf6;
    outline-offset: 3px;
  }

  @media screen and (max-width: 520px) {
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 0.76rem;
    min-height: 5.1rem;
    padding: 0.72rem 0.78rem;
    border-radius: 15px;
  }
`;

export const IconBox = styled.span<{ $complete?: boolean }>`
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  color: ${({ $complete }) => ($complete ? "#75f0a0" : "#b783ff")};
  border: 1px solid
    ${({ $complete }) =>
      $complete ? "rgba(117, 240, 160, 0.42)" : "rgba(159, 91, 255, 0.38)"};
  background: ${({ $complete }) =>
    $complete
      ? "rgba(26, 91, 45, 0.28)"
      : "linear-gradient(145deg, rgba(96, 43, 155, 0.5), rgba(31, 24, 62, 0.78))"};
  box-shadow: ${({ $complete }) =>
    $complete ? "none" : "0 10px 28px rgba(96, 43, 155, 0.18)"};

  svg {
    width: 21px;
    height: 21px;
    stroke-width: 2.15;
  }

  @media screen and (max-width: 520px) {
    width: 44px;
    height: 44px;
    border-radius: 14px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const StepText = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;

  h3 {
    margin: 0 0 0.2rem;
    color: #ffffff;
    font-size: 1.2rem;
    line-height: 1.18;
    font-weight: 650;
    letter-spacing: 0;
  }

  p {
    margin: 0;
    color: #9aa8bd;
    font-size: 0.96rem;
    line-height: 1.34;
    overflow-wrap: anywhere;
  }

  @media screen and (max-width: 520px) {
    h3 {
      font-size: 1.08rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
`;

export const Footer = styled.p`
  margin: 1.25rem 0 0;
  color: #9aa8bd;
  font-size: 0.98rem;
  line-height: 1.4;
  text-align: center;
`;
